// The About bar (fixed overlay, z-30) and the MapLibre attribution pill
// (inside the map container) overlap at the bottom of the screen. Whichever
// was interacted with most recently must render on top. MapLibre controls
// scale the map container's own stacking context, so a DOM-level toggle is
// the only reliable way to reorder them — subscribers bump their element's
// z-index while they hold the top slot.
let top: 'attrib' | 'infobar' = 'infobar'

const listeners = new Set<() => void>()

const emit = () => listeners.forEach((l) => l())

export const bringAttributionToFront = () => {
  if (top !== 'attrib') {
    top = 'attrib'
    emit()
  }
}

export const bringInfoBarToFront = () => {
  if (top !== 'infobar') {
    top = 'infobar'
    emit()
  }
}

export const subscribeOverlayStack = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export const getOverlayTop = () => top
